function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.3351 10.8497L11.4856 2.0067C11.4219 1.94285 11.3462 1.8922 11.2629 1.85764C11.1796 1.82309 11.0903 1.8053 11.0001 1.8053C10.9099 1.8053 10.8206 1.82309 10.7373 1.85764C10.654 1.8922 10.5783 1.94285 10.5146 2.0067L1.66514 10.8497C1.40732 11.1075 1.26123 11.4577 1.26123 11.8229C1.26123 12.5813 1.87783 13.1979 2.63623 13.1979H3.56865V19.5079C3.56865 19.8881 3.87588 20.1954 4.25615 20.1954H9.6251V15.3829H12.0313V20.1954H17.744C18.1243 20.1954 18.4315 19.8881 18.4315 19.5079V13.1979H19.364C19.7292 13.1979 20.0794 13.054 20.3372 12.794C20.8722 12.2569 20.8722 11.3868 20.3351 10.8497V10.8497Z",
  fill: "white"
});

const SvgHome = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.6bd37b7e.svg";
export { ForwardRef as ReactComponent };